import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

export interface Column {
  key: string; // field key in row
  label: string; // header label
  render?: (value: any, row: any) => React.ReactNode;
  sortable?: boolean;
  onSort?: () => void;
}

export interface CustomTableProps {
  columns: Column[];
  rows: any[];
  handleClick?: (row: any) => void;
}

export const getStatusColor = (status: string) => {
  switch (status) {
    case "Actif":
      return "green";
    case "verified":
      return "green";
    case "Expiré":
      return "orange";
    case "Bloqué":
      return "red";
    case "Inactif":
      return "gray";
    case "En cours":
      return "green";
    case "A venir":
      return "blue";
    case "Terminé":
      return "gray";
    case "Annulé":
      return "red";
    default:
      return "black";
  }
};

export const getReservationStatus = (
  status: string
): { label: string; color: string } => {
  switch (status) {
    case "pending":
      return { label: "À venir", color: "#2196F3" };
    case "confirmed":
      return { label: "En cours", color: "#4CAF50" };
    case "completed":
      return { label: "Terminée", color: "#9E9E9E" };
    case "cancelled":
      return { label: "Annulée", color: "#F44336" };
    default:
      return { label: status, color: "#000" };
  }
};

export const convertStatus = (status: string) => {
  switch (status) {
    case "active":
      return "Actif";
    case "verified":
      return "Actif";
    case "inactive":
      return "Inactif";
    case "expired":
      return "Expiré";
    case "blocked":
      return "Bloqué";
    default:
      return status;
  }
};

export const CustomTableComponent: React.FC<CustomTableProps> = ({
  columns,
  rows,
  handleClick,
}) => {
  return (
    <TableContainer
      component={Paper}
      sx={{ borderRadius: 2, backgroundColor: "#FFFDF7" }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell
                key={col.key}
                onClick={col.sortable ? col.onSort : undefined}
                sx={{
                  fontWeight: "bold",
                  fontSize: "0.78rem",
                  color: "#9d0049",
                  borderBottom: "2px solid #9d0049",
                  cursor: col.sortable ? "pointer" : "default",
                  userSelect: col.sortable ? "none" : "auto",
                }}
              >
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((row, idx) => (
            <TableRow
              key={idx}
              onClick={() => handleClick && handleClick(row)}
              sx={{
                cursor: "pointer",
              }}
            >
              {columns.map((col) => {
                const value = row[col.key];

                // If custom renderer exists use it
                if (col.render) {
                  return (
                    <TableCell key={col.key} sx={{ fontSize: "0.78rem" }}>
                      {col.render(value, row)}
                    </TableCell>
                  );
                }

                // Default rendering
                return (
                  <TableCell key={col.key} sx={{ fontSize: "0.78rem" }}>
                    {value}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
